<template>
	<c-dialog ref="dialog" title="工单详情" mode="slide" width="100vw-300" @close="beforeClose();" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.work_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.work_code}}</label>
				<c-state dict="orderStateDic" tag :value="detailData.work_state"></c-state>
				<c-state type="expectedDate" tag :value="detailData.expected_date"></c-state>
				<c-state dict="priorityDic" tag :value="detailData.priority"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="工单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="工单进度">
						<c-progress :rate="[detailData.ok_count, detailData.plan_count]" :color="((detailData.ok_count/detailData.plan_count)>=1||detailData.plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="产品编号">
						{{detailData.product_code}}
					</c-detail-item>
					<c-detail-item label="产品名称">
						{{detailData.product_name}}
					</c-detail-item>
					<c-detail-item label="产品规格">
						{{detailData.product_spec}}
					</c-detail-item>
					<c-detail-item label="产品类型">
						<c-state dict="productTypeName" :value="detailData.product_type"></c-state>
					</c-detail-item>
					<c-detail-item label="产品单位">
						{{detailData.unit}}
					</c-detail-item>
					<c-detail-item label="产品来源">
						<c-state dict="productSourceName" :value="detailData.product_source"></c-state>
					</c-detail-item>
					<c-detail-item label="计划数">
						<b>{{detailData.plan_count}}</b>
					</c-detail-item>
					<c-detail-item label="完成数">
						<b>{{detailData.ok_count}}</b>
					</c-detail-item>
					<c-detail-item label="待完成数">
						<b>{{detailData.undone_count}}</b>
					</c-detail-item>
					<c-detail-item label="计划开始时间">
						{{detailData.plan_start_date}}
					</c-detail-item>
					<c-detail-item label="计划结束时间">
						{{detailData.plan_end_date}}
					</c-detail-item>
					<c-detail-item label="实际开始时间">
						{{detailData.real_start_date}}
					</c-detail-item>
					<c-detail-item label="实际结束时间">
						{{detailData.real_end_date}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间">
						{{detailData.create_date}}
					</c-detail-item>
					<c-detail-item label="备注说明">
						{{detailData.remark}}
					</c-detail-item>
					<c-detail-item v-if="detailData.customer_name" label="客户">
						{{detailData.customer_name}}
					</c-detail-item>
					<c-detail-item v-if="detailData.order_code != detailData.ref_code" label="销售订单">
						<c-link v-if="auth('m_order')" @click="globalDialog('orderDetail', {props: {id: detailData.order_id}})">{{detailData.order_code}}</c-link>
						<span v-else>{{detailData.order_code}}</span>
					</c-detail-item>
					<c-detail-item v-if="detailData.ref_code" label="关联单据">
						<order-link :type="detailData.ref_type" :id="detailData.ref_id" :code="detailData.ref_code"></order-link>
					</c-detail-item>
					<custom-detail work-type="3" :data="detailData.custom_fields_value_json"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="工单信息" enable-flex>
					<div class="m-detail-box">
						<c-title>任务信息</c-title>
						<custom-table ref="taskTable" view-id="20004" height="grow" readonly>
							<!--任务状态-->
							<template #state="{data}">
								<c-state dict="orderStateDic" tag :value="data.state"></c-state>
							</template>

							<!--优先级-->
							<template #priority="{data}">
								<c-state dict="priorityDic" tag :value="data.priority"></c-state>
							</template>

							<!--任务分配 -->
							<template #output_distribute_auth_names="{data}">
								<c-tags v-if="data.output_distribute_auth_names" :value="data.output_distribute_auth_names"></c-tags>
							</template>
							
							<!--加工类型-->
							<template #process_type="{data}">
								<c-state dict="processTypeDic" :value="data.process_type"></c-state>
							</template>
							
							<!--检验方式-->
							<template #test_mode="{data}">
								<c-state dict="testModeDic" :value="data.test_mode"></c-state>
							</template>
							
							<!--自动出库-->
							<template #material_auto_out="{data}">
								<c-state dict="openCloseDic" :value="data.material_auto_out"></c-state>
							</template>
							
							<!--自动入库-->
							<template #product_auto_in="{data}">
								<c-state dict="openCloseDic" :value="data.product_auto_in"></c-state>
							</template>
					
							<!--任务进度%-->
							<template #task_progress="{data}">
								<c-progress :rate="[data.fine_count, data.plan_count]" :color="((data.fine_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
							</template>
						</custom-table>

						<c-title>用料信息</c-title>
						<c-table ref="materialTable" border height="grow" width-resize style="min-height: 200px;">
							<c-table-column label="产品编号" width="150" name="product_code"></c-table-column>
							<c-table-column label="产品名称" width="200" name="product_name"></c-table-column>
							<c-table-column label="产品规格" width="150" name="product_spec"></c-table-column>
							<c-table-column label="单位" width="70" name="unit"></c-table-column>
							<c-table-column label="产品类型" width="70">
								<template #default="{data}">
									<c-state dict="productTypeName" :value="data.product_type"></c-state>
								</template>
							</c-table-column>
							<c-table-column label="产品来源" width="70">
								<template #default="{data}">
									<c-state dict="productSourceName" :value="data.product_source"></c-state>
								</template>
							</c-table-column>
							<c-table-column label="单位用量" width="100" name="unit_count"></c-table-column>
							<c-table-column label="投料工序" width="200" name="process_name"></c-table-column>
							<c-table-column label="预计用量" width="80" name="plan_count"></c-table-column>
							<c-table-column label="当前库存" width="90">
								<template #default="{data, index}">
									<c-link v-if="data.product_count != 0" :ref="`stock${index}`" @click="stockHandle(data, index)">{{data.product_count}}</c-link>
									<span v-else>{{data.product_count}}</span>
								</template>
							</c-table-column>
							<c-table-column label="已领料数" width="70" name="picking_count"></c-table-column>
							<c-table-column label="已退料数" width="70" name="eject_count"></c-table-column>
							<c-table-column label="说明备注" width="130" name="remark"></c-table-column>
						</c-table>
					</div>
				</module-tab>

				<module-tab name="报工记录" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="outputTable" view-id="20005" height="grow" paging readonly>
							<!--计价方式-->
							<template #pricing_type="{data}">
								<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
							</template>

							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>

							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--工单状态-->
							<template #work_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
							</template>
							
							<!--任务状态-->
							<template #task_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.task_state"></c-state>
							</template>
							
							<!--工资单价-->
							<template #price="{data}">
								￥{{parseFloat(parseFloat(data.price).toFixed(6))}}
							</template>
							
							<!--预计工资-->
							<template #pre_salary="{data}">
								￥{{parseFloat(data.pre_salary).toFixed(2)}}
							</template>
							
							<!--审批状态-->
							<template #state="{data}">
								<c-state dict="auditStateDic" tag :value="data.state"></c-state>
							</template>
							
							<!--报工良品率-->
							<template #fine_ratio="{data}">
								{{data.fine_ratio}}%
							</template>
							
							<!--检验方式-->
							<template #test_mode="{data}">
								<c-state dict="testModeDic" :value="data.test_mode"></c-state>
							</template>
							
							<!--检验状态-->
							<template #test_state="{data}">
								<c-state dict="testStateDic" :value="data.test_state"></c-state>
							</template>
							
							<!--质检人-->
							<template #test_user_realname="{data}">
								<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
								<span v-else>-</span>
							</template>
							
							<!--质检时间-->
							<template #test_date="{data}">
								<span v-if="data.test_state == 3">{{data.test_date}}</span>
								<span v-else>-</span>
							</template>
							
							<!--质检数-->
							<template #test_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检数-合计行-->
							<template #test_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检合格数-->
							<template #test_fine_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_fine_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检合格数-合计行-->
							<template #test_fine_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检不合格数-->
							<template #test_defects_count="{data}">
								<span v-if="data.test_state == 3">{{data.test_defects_count}}</span>
								<span v-else>-</span>
							</template>
							<!--质检不合格数-合计行-->
							<template #test_defects_count_summed="{total}">
								{{total}}
							</template>
							
							<!--质检良品率-->
							<template #test_fine_ratio="{data}">
								<span v-if="data.test_state == 3">{{data.test_fine_ratio}}%</span>
								<span v-else>-</span>
							</template>
						</custom-table>
					</div>
				</module-tab>
				
				<module-tab name="质检记录" enable-flex>
					<div class="m-detail-box">
						<custom-table ref="qualityTable" view-id="20023" height="grow" readonly>
							<!--审核状态-->
							<template #approve_state="{data}">
								<c-state dict="auditState2Dic" :value="data.approve_state"></c-state>
							</template>
							
							<!--质检良品率-->
							<template #test_fine_ratio="{data}">
								{{parseFloat((data.test_fine_count*100/data.test_count).toFixed(6))}}%
							</template>
						</custom-table>
					</div>
				</module-tab>

				<module-tab name="烘烤记录" enable-flex>
					<div class="m-detail-box">
						<c-table ref="bakeTaskTable" border height="grow" width-resize style="min-height: 200px;">
							<c-table-column label="机台-点位" width="140">
								<template #default="{data}">
									{{ data.equipment_code || '-' }} · {{ data.point_code != null ? data.point_code : '-' }}
								</template>
							</c-table-column>
							<c-table-column label="目标温度" width="110">
								<template #default="{data}">
									<span v-if="data.target_temp != null">{{ data.target_temp }}℃<small v-if="data.temp_tolerance">±{{ data.temp_tolerance }}℃</small></span>
									<span v-else>-</span>
								</template>
							</c-table-column>
							<c-table-column label="目标时长" width="100">
								<template #default="{data}">
									{{ data.target_duration != null ? formatMinutes(data.target_duration) : '-' }}
								</template>
							</c-table-column>
							<c-table-column label="计划数量" width="90" name="plan_count"></c-table-column>
							<c-table-column label="已烘烤时长" width="100">
								<template #default="{data}">
									<span :class="{'bake-state-warming': data.is_warming_up == 1}">{{ data.is_warming_up == 1 ? '升温中' : formatMinutes(data.effective_bake_minutes) }}</span>
								</template>
							</c-table-column>
							<c-table-column label="下发状态" width="90">
								<template #default="{data}">
									<c-state dict="bakeSyncStatusDic" :value="data.sync_status != null ? data.sync_status : 0"></c-state>
								</template>
							</c-table-column>
							<c-table-column label="烘烤状态" width="120">
								<template #default="{data}">
									<c-state dict="bakeStateDic" :value="data.bake_state" v-if="data.bake_state != 2"></c-state>
									<span v-else :class="{'bake-state-warming': data.is_warming_up == 1}">{{ data.is_warming_up == 1 ? '升温中' : '烘烤中' }}</span>
									<span v-if="data.is_duration_met == 1 && data.bake_state == 2" class="duration-met-badge">待确认</span>
								</template>
							</c-table-column>
							<c-table-column label="开始时间" width="150" name="start_time"></c-table-column>
							<c-table-column label="结束时间" width="150" name="end_time"></c-table-column>
						</c-table>
					</div>
				</module-tab>
			</module-col>
		</module>
		
		
		<!--产品库存明细数据-->
		<c-window ref="stockWin" :title="stock_product_info+' - 库存明细'" align="start" height="160" width="220">
			<c-table ref="stockList" :paging="false">
				<c-table-column
					label="所属仓库"
					width="140"
					name="warehouse_name"
				>
					<template #default="{data}">
						<span v-if="data.product_count == 0" style="color:darkgrey;">{{data.warehouse_name}}</span>
						<span v-else>{{data.warehouse_name}}</span>
					</template>
				</c-table-column>
				<c-table-column
					label="库存"
					width="80"
					name="product_count"
				>
					<template #default="{data}">
						<span v-if="data.product_count == 0" style="color:darkgrey;">{{data.product_count}}</span>
						<span v-else>{{data.product_count}}</span>
					</template>
				</c-table-column>
			</c-table>
		</c-window>
	</c-dialog>
</template>

<script>
	export default {
		name: 'workDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {},
				stock_product_info:''
			}
		},

		methods: {
			formatMinutes(minutes) {
				let m = parseInt(minutes) || 0
				if (m <= 0) return '0分钟'
				if (m < 60) return m + '分钟'
				let hours = Math.floor(m / 60)
				let left = m % 60
				return left > 0 ? hours + '小时' + left + '分' : hours + '小时'
			},

			open() {
				this.request({
					url: '/work/overview',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.taskTable.init();
						this.$refs.outputTable.init();
						this.$refs.taskTable.$refs.list.setData(data.taskList);
						this.$refs.materialTable.setData(data.materialList);
						
						this.$refs.qualityTable.init();
						this.$refs.qualityTable.$refs.list.setData(data.qualitList);
						this.$refs.outputTable.$refs.list.load({
							url: '/output/list',
							data: {
								view_id: 20005,
								work_id: this.id
							}
						});
						this.$refs.bakeTaskTable.clear();
						this.request({
							url: '/bake/task/list',
							data: {work_id: this.id},
							success: bakeList => {
								this.$refs.bakeTaskTable.setData(bakeList || []);
							}
						});
						this.$refs.dialog.open();
					}
				});
			},
		
			stockHandle(data, index) {
				this.$refs.stockList.clear();
				this.stock_product_info = data.product_code;
				//历史库存明细数据
				this.request({
					url: '/stock/product/detail/nopagelist',
					data: {
						product_id: data.product_id
					},
					success: detailList => {
						this.$refs.stockList.setData(detailList);
						this.$refs.stockWin.show(this.$refs[`stock${index}`]);
					}
				});
			},
			
			beforeClose() {
				if (this.$refs.stockWin) {
					this.$refs.stockWin.hide();
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.bake-state-warming {
		color: #ff9800;
	}
	.duration-met-badge {
		display: inline-block;
		margin-left: 6px;
		padding: 0 4px;
		font-size: 12px;
		color: #fff;
		background: #52c41a;
		border-radius: 2px;
		line-height: 18px;
	}
</style>